import { combineReducers, createStore, applyMiddleware } from 'redux';
import { routeChange } from '../actions/Index';
import thunk from 'redux-thunk';
import * as ActionTypes from '../actions/HttpRequest';

const reducer = combineReducers({
  login: ActionTypes.login.reducer,
  GetPurchaseOrder: ActionTypes.GetPurchaseOrder.reducer,
  Getstates: ActionTypes.Getstates.reducer,
  Export: ActionTypes.Export.reducer,
  GetPurchaseOrderDetail: ActionTypes.GetPurchaseOrderDetail.reducer,
  UpdatePurchaseOrderDetail: ActionTypes.UpdatePurchaseOrderDetail.reducer,
  POStatusReport: ActionTypes.POStatusReport.reducer,
  PrintPO: ActionTypes.PrintPO.reducer,
  GetClaims: ActionTypes.GetClaims.reducer,
  GetClaimDetail: ActionTypes.GetClaimDetail.reducer,
  PrintClaim: ActionTypes.PrintClaim.reducer,
  ClaimExport: ActionTypes.ClaimExport.reducer,
  ClaimStatusReport: ActionTypes.ClaimStatusReport.reducer,
  routeChange: routeChange
});

const initialState = {};

export default createStore(
  reducer,
  initialState,
  applyMiddleware(thunk)
)